<template>
  <!-- 统一复用 -->
  <div class="commonHeader">
    <div class="header nyheader" style="top: 0px">
      <div class="content">
        <a href="/">
          <div class="logo" id="content_logo">
            <img
              src="https://rayneo.cn/fileResources/upload/2023/02/08/2c7190cf-684f-4bde-bded-9038f263909d.png"
              alt="雷鸟创新技术（深圳）有限公司"
              class="blogo"
            />
            <img
              src="https://rayneo.cn/fileResources/upload/2023/02/08/2c7190cf-684f-4bde-bded-9038f263909d.png"
              alt="雷鸟创新技术（深圳）有限公司"
              class="wlogo"
            />
          </div>
        </a>
        <div class="nav_handle" @click="openMenu = true">
          <img src="../../../assets/images/menu.png" alt="" />
        </div>
        <div class="inmuen">
          <ul id="ul">
            <a
              target="_blank"
              :href="item.ext || item.url"
              v-for="(item, index) in menuData"
              :key="index"
            >
              <li>{{ item.channelName }}</li>
            </a>
          </ul>
        </div>
        <div class="clean"></div>
      </div>
    </div>

    <div class="wapmuen" :class="openMenu ? 'on' : ''">
      <div class="top">
        <div class="logo">
          <img
            src="https://rayneo.cn/fileResources/upload/2023/02/08/2c7190cf-684f-4bde-bded-9038f263909d.png"
            alt="雷鸟创新技术（深圳）有限公司"
          />
        </div>
        <a @click="openMenu = false" href="JavaScript:;" class="close">
          <img src="../../../assets/images/close.png" alt="" />
        </a>
      </div>
      <div class="list">
        <ul id="p_ul">
          <a
            :href="item.ext || item.url"
            v-for="(item, index) in menuData"
            :key="index"
          >
            <li>{{ item.channelName }}</li>
          </a>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.header.nyheader {
  position: fixed;
  top: 0px;
  left: 0px;
}

.header .content {
  height: auto;
  margin: 0 auto;
  box-sizing: border-box;
  width: 1200px;
}

.nav_handle {
  display: none;
  position: absolute;
  width: 50px;
  cursor: pointer;
  height: 50px;
  right: 0px;
  top: 0px;
}

.nav_handle img {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}

.nav_handle b i {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #000;
  top: 0;
  -webkit-transform-origin: 29% 50%;
  transform-origin: 29% 50%;
  transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
}

.nav_handle b .l_2 {
  top: auto;
  bottom: 0;
}

.header {
  width: 100%;
  z-index: 99;
  background: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0);
}

.header .logo {
  position: relative;
  margin: 31px 0;
  float: left;
  transition: all 0.5s;
}

.header .logo img {
  /* prettier-ignore */
  height: 18PX;
  display: block;
  transition: all 0.5s;
}

.header .logo .blogo {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  /* prettier-ignore */
  height: 18PX;
  opacity: 0;
}

.header .lang {
  float: right;
  color: #fff;
  margin: 30px 0;
  padding: 0 15px;
  transition: all 0.5s;
}

.header .lang span {
  opacity: 0.6;
}

.header .lang a {
  color: #fff;
  opacity: 0.6;
  transition: all 0.5s;
}

.header .lang a:hover {
  opacity: 1;
}

.header .inmuen {
  float: right;
}

.header .inmuen ul li {
  display: block;
  margin: 30px 0;
  float: left;
  padding: 0 15px;
  color: #fff;
  opacity: 0.6;
  transition: all 0.5s;
  font-family: SourceHanSansSC-Medium;
}

.header .inmuen ul li:hover,
.header .inmuen ul li.on {
  opacity: 1;
}

.header.nyheader {
  background: #fff;
}

.header.nyheader .logo .blogo {
  opacity: 1;
}

.header.nyheader .lang {
  color: #000;
  opacity: 1;
}

.header.nyheader .lang a {
  color: #000;
  opacity: 1;
}

.header.nyheader .lang a:hover {
  color: #1256ff;
}

.header.nyheader .inmuen ul li {
  opacity: 1;
  color: #000;
  /* prettier-ignore */
  font-size: 14PX;
}

.header.nyheader .inmuen ul li:hover,
.header.nyheader .inmuen ul li.on {
  color: #1256ff;
}

.headerkg {
  height: 81px;
}

.header.header_on {
  position: fixed;
  background: #fff;
  border-bottom: 1px solid #eaecef;
  z-index: 900;
}

.header.header_on .logo .blogo {
  opacity: 1;
}

.header.header_on .lang {
  color: #000;
  opacity: 1;
}

.header.header_on .lang span {
  opacity: 1;
}

.header.header_on .lang a {
  color: #000;
  opacity: 1;
}

.header.header_on .lang a:hover {
  color: #1256ff;
}

.header.header_on .inmuen ul li {
  opacity: 1;
  color: #000;
}

.header.header_on .inmuen ul li:hover,
.header.header_on .inmuen ul li.on {
  color: #1256ff;
}

.wapmuen {
  display: none;
}

.clean {
  display: block;
  width: 100%;
  clear: both;
}

/* 手机端 */
@media only screen and (max-width: 950px) {
  .header {
    background: #fff;
    width: 100%;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  }

  .header.nyheader {
    position: fixed;
    top: 0px;
    left: 0px;
  }

  .header .logo .blogo {
    opacity: 1;
    height: 18px;
    position: static;
    display: block;
    width: auto;
  }

  .header .logo .wlogo {
    display: none;
  }

  .header .logo {
    margin: 16px;
  }

  .nav_handle {
    display: block;
  }

  .header .lang {
    display: none;
  }

  .header .inmuen {
    display: none;
  }

  .wapmuen {
    display: block;
    transition: all 0.8s;
    position: fixed;
    z-index: 999;
    background: #fff;
    width: 100%;
    height: 100%;
    left: 100%;
    top: 0;
    padding: 0 10px;
    box-sizing: border-box;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  }

  .wapmuen .top:after {
    content: "";
    display: block;
    width: 100%;
    clear: both;
  }

  .wapmuen .top .logo {
    float: left;
    padding: 16px 0;
  }

  .wapmuen .top .logo img {
    height: 18px !important;
    width: auto !important;
    display: block;
  }

  .wapmuen .top .close {
    display: block;
    width: 27px;
    line-height: 50px;
    text-align: center;
    float: right;
    font-size: 20px;
    color: #000;
  }

  .wapmuen .list {
    padding: 20px 0;
  }

  .wapmuen .list a {
    text-decoration: none;
    color: #000;
  }

  .wapmuen .list ul li {
    display: block;
    height: 45px;
    line-height: 45px;
    font-size: 15px;
    border-bottom: 1px solid #eee;
  }

  .wapmuen .list ul li:hover,
  .wapmuen .list ul li.on {
    color: #1256ff;
  }

  .wapmuen .lang {
    position: absolute;
    font-size: 12px;
    color: #ccc;
    bottom: 20px;
    left: 5px;
  }

  .wapmuen .lang a {
    padding: 0 5px;
    display: inline-block;
  }

  .wapmuen.on {
    left: 0;
  }

  .wapmuen .close img {
    width: 30px;
    height: 30px;
    margin-top: 10px;
  }
}
</style>

<script>
import { getHeader } from "../../../serverice/api";
export default {
  data() {
    return {
      menuData: [],
      openMenu: false,
    };
  },
  created() {
    this.getHeaderFun();
  },
  methods: {
    async getHeaderFun() {
      try {
        let res = await getHeader();
        this.menuData = (res.data || {}).data || [];
      } catch (error) {
        console.error("[Header] Fetch menu header failed:", error);
      }
    },
    handleToOpen() {},
  },
};
</script>
